import cookies from '../browser/cookies';

/**
 * 设置cookieisInner的值为true。因为通天塔登录需要cookie中有isInner属性并且值是true
 */
function injectCookieForBabelLogin() {
  if (cookies.getItem('isInner')) return;

  cookies.setItem('isInner', 'true', undefined, '/', '.jd.com');
}

export { injectCookieForBabelLogin };
